var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCoffe(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3914_24314)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6438 5.68685H1.55196C-0.102828 8.49654 2.30942 10.3979 4.23227 10.1436C6.42312 15.109 12.7011 12.8443 12.8442 8.79931C12.8775 7.85531 12.9024 6.36505 12.8442 5.68685H11.6438M11.6438 5.68685V7.20069M11.6438 7.81834C11.671 9.11015 11.0192 11.6938 8.1944 11.6938M7.54181 1C7.5923 1.09285 7.46929 1.50539 7.38538 1.63134C7.2805 1.78878 6.94748 1.95675 7.32039 2.75606C7.61872 3.3955 7.47577 3.93483 7.367 4.12457C7.23882 4.33045 7.09665 4.8173 7.367 5.02076M9.3714 1C9.42189 1.09285 9.47861 1.37059 9.3947 1.49654C9.28982 1.65398 8.77707 1.95675 9.14998 2.75606C9.44831 3.3955 9.30536 3.93483 9.19659 4.12457C9.06841 4.33045 8.92623 4.8173 9.19659 5.02076M1.55196 13.8495H14.5222M15 13.8495H14.5222M2.21196 13.8495L2.5891 15H14.0095L14.5222 13.8495M2.0647 6.74048H3.85932C3.82436 7.48731 3.95255 9.16263 3.95255 9.16263C1.99478 9.16263 1.87824 7.54787 2.0647 6.74048",
    stroke: "#202020",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3914_24314"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoffe);
export default __webpack_public_path__ + "static/media/coffe.e28d79b0d4bab27cdbc4f1fab814f755.svg";
export { ForwardRef as ReactComponent };